/**
 * 用户认证服务 API 接口
 */
import axios from 'axios';
import axiosInstance from './axiosConfig';
import { API_CONFIG } from './config';

// 本地存储的token键名
const TOKEN_KEY = 'hammerath_auth_token';

/**
 * 用户登录
 * @param {string} username - 用户名
 * @param {string} password - 密码
 * @returns {Promise} - 包含登录结果的 Promise
 */
export const login = async (username, password) => {
  try {
    const response = await axiosInstance.post(
      `${API_CONFIG.AUTH.BASE_URL}${API_CONFIG.AUTH.LOGIN}`,
      { username, password }
    );
    
    const result = response.data;
    
    if (result.success && result.token) {
      // 保存token到本地存储
      localStorage.setItem(TOKEN_KEY, result.token);
    }
    
    return result;
  } catch (error) {
    console.error('登录时出错:', error);
    return {
      success: false,
      error: `登录请求失败: ${error.message || '未知错误'}`,
    };
  }
};

/**
 * 用户注册
 * @param {string} username - 用户名
 * @param {string} password - 密码
 * @param {string} email - 电子邮件
 * @returns {Promise} - 包含注册结果的 Promise
 */
export const register = async (username, password, email) => {
  try {
    const response = await axiosInstance.post(
      `${API_CONFIG.AUTH.BASE_URL}${API_CONFIG.AUTH.REGISTER}`,
      { username, password, email }
    );

    return response.data;
  } catch (error) {
    console.error('注册时出错:', error);
    return {
      success: false,
      error: `注册请求失败: ${error.message || '未知错误'}`,
    };
  }
};

/**
 * 验证当前token是否有效
 * @returns {Promise<boolean>} - token是否有效
 */
export const verifyToken = async () => {
  const token = localStorage.getItem(TOKEN_KEY);
  
  if (!token) {
    return false;
  }
  
  try {
    const response = await axiosInstance.post(
      `${API_CONFIG.AUTH.BASE_URL}${API_CONFIG.AUTH.VERIFY}`
    );

    const result = response.data;
    return result.success === true;
  } catch (error) {
    console.error('验证token时出错:', error);
    return false;
  }
};

/**
 * 用户注销
 * @returns {Promise} - 包含注销结果的 Promise
 */
export const logout = async () => {
  const token = localStorage.getItem(TOKEN_KEY);
  
  // 移除本地token
  localStorage.removeItem(TOKEN_KEY);
  
  if (!token) {
    return { success: true };
  }
  
  try {
    const response = await axiosInstance.post(
      `${API_CONFIG.AUTH.BASE_URL}${API_CONFIG.AUTH.LOGOUT}`
    );

    return response.data;
  } catch (error) {
    console.error('注销时出错:', error);
    // 即使服务器请求失败，客户端也认为注销成功
    return { success: true };
  }
};

/**
 * 获取当前的认证token
 * @returns {string|null} - 认证token或null
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * 检查用户是否已登录
 * @returns {boolean} - 是否已登录
 */
export const isLoggedIn = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

export default {
  login,
  register,
  logout,
  verifyToken,
  getToken,
  isLoggedIn,
}; 